import { isFeatureActive } from '@helpers';
import { del, post, get } from '@common/Http';
import { hasInvalidDataFormat } from '@common/Product/helpers';
import { getRealListValue } from '@common/Tracking/RealList';
import { loadState } from '@helpers/localStorage';
import { loadSession, saveSession } from '@helpers/sessionStorage';
import {
    API_RECENT_PRODUCT_ADD,
    API_RECENT_PRODUCT_LIST,
    RECENT_PRODUCT_DELETE,
    RECENT_PRODUCTS_DELETE
} from '@routes';
import { recentsCacheName, RECENTS_SESSION_CACHE_NAME } from '../constants/cache';
import {
    FETCH_RECENTS_REQUEST,
    FETCH_RECENTS_SUCCESS,
    FETCH_RECENTS_FAILURE,
    ADD_RECENTS_REQUEST,
    ADD_RECENTS_SUCCESS,
    ADD_RECENTS_FAILURE,
    DELETE_RECENTS_REQUEST,
    DELETE_RECENTS_SUCCESS,
    DELETE_RECENTS_FAILURE,
    REORDER_RECENTS
} from './actionsConstants';

export const getData = () => {
    if (window.history.length <= 1) {
        sessionStorage.removeItem(RECENTS_SESSION_CACHE_NAME);
    }

    return { type: FETCH_RECENTS_REQUEST };
};

export const addData = () => ({ type: ADD_RECENTS_REQUEST });

export const deleteData = () => ({ type: DELETE_RECENTS_REQUEST });

export const reorderData = variantId => ({ type: REORDER_RECENTS, payload: variantId });

const setRecents = data => ({
    type: FETCH_RECENTS_SUCCESS,
    payload: data
});

export const getDataSuccess = (response) => {
    saveSession(RECENTS_SESSION_CACHE_NAME, Date.now());
    return {
        type: FETCH_RECENTS_SUCCESS,
        payload: response.data?.products || response.product_cards
    };
};

export const addDataSuccess = response => ({
    type: ADD_RECENTS_SUCCESS,
    payload: response.data?.product || response.product_card?.[0]
});

export const deleteDataSuccess = variantId => ({ type: DELETE_RECENTS_SUCCESS, payload: variantId });

export const getDataError = err => ({ type: FETCH_RECENTS_FAILURE, err });

export const addDataError = err => ({ type: ADD_RECENTS_FAILURE, err });

export const deleteDataError = err => ({ type: DELETE_RECENTS_FAILURE, err });

export const isRecentsSessionExpired = () => {
    const session = loadSession(RECENTS_SESSION_CACHE_NAME);
    let timediff = 11;

    if (typeof session !== 'undefined') {
        timediff = Math.floor((Date.now() - session) / 1000 / 60);
    }

    return timediff > 10;
};

export const fetchRecents = (hasToBumpCache = false) => async (dispatch) => {
    dispatch(getData());
    const cachedRecents = loadState(recentsCacheName);

    if (
        hasToBumpCache
        || isRecentsSessionExpired()
        || isFeatureActive('T74590_mylists_no_cache')
        || hasInvalidDataFormat(cachedRecents)
    ) {
        try {
            const response = await get(API_RECENT_PRODUCT_LIST);

            dispatch(getDataSuccess(response));
        } catch (error) {
            dispatch(getDataError(error));
        }
    } else if (cachedRecents?.length > 0) {
        dispatch(setRecents(cachedRecents));
    }
};

export const addRecents = variant => async (dispatch, getState) => {
    dispatch(addData());
    // check if variant is already in store
    const { products } = getState().recents;

    let isVariantInStore = false;

    if (products) {
        isVariantInStore = products.some((product) => {
            const variantId = product.variant_id || product.variants?.[0].id;
            return String(variantId) === String(variant);
        });
    }

    if (isVariantInStore) {
        dispatch(reorderData(String(variant)));
    } else {
        post(API_RECENT_PRODUCT_ADD, {
            variant_id: variant,
            real_list: getRealListValue()
        }).then((response) => {
            dispatch(addDataSuccess(response));
        }).catch(error => dispatch(addDataError(error)));
    }
};

export const deleteRecents = variant => async (dispatch) => {
    let route = RECENT_PRODUCTS_DELETE;
    let parameters;

    dispatch(deleteData());

    if (variant !== '') {
        route = RECENT_PRODUCT_DELETE;
        parameters = { variantIds: variant };
    }

    try {
        await del(route, parameters);
        dispatch(deleteDataSuccess(variant));
    } catch (error) {
        dispatch(deleteDataError(error));
    }
};
